<template>
  <div class="body">
    <el-card class="box_card">
      <div class="header">
        <div class="header_title bold">OCR数据查询</div>
        <div class="header_right">
          <div class="header_item">
            <span class="item_title"> 时间选择：</span>
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :clearable="false"
              @change="chooseDate"
            >
            </el-date-picker>
          </div>
          <div class="header_item">
            <span class="item_title">样本类型：</span>
            <el-select v-model="typeValue" placeholder="请选择" @change="chooseType">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="header_item">
            <el-input
              v-model="searchName"
              placeholder="输入搜索的条码"
              clearable
              prefix-icon="el-icon-search"
              @clear="clearSearchName"
              @keyup.enter.native="goSearch"
            ></el-input>
          </div>
          <div class="header_item">
            <el-button type="primary" plain icon="el-icon-search" size="small" @click="goSearch">搜索</el-button>
            <el-button type="warning" plain icon="el-icon-printer" size="small" @click="exportInfo">导出</el-button>
          </div>
        </div>
      </div>
      <div class="middle_table">
        <el-table
          :data="tableData"
          ref="multipleTable"
          v-loading="laodTable"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          border
          style="width: 100%"
          height="100%"
        >
          <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
          <el-table-column prop="barcode" label="条形码" width="120" align="center"> </el-table-column>
          <!-- <el-table-column prop="orderStaus" label="结算状态" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="row.orsl_Payment_status === '已结算'">{{ row.orsl_Payment_status }}</el-tag>
              <el-tag type="info" v-if="row.orsl_Payment_status === ''">未结算</el-tag>
              <el-tag type="warning" v-if="row.orsl_Payment_status === '准备支付' || row.orsl_Payment_status === '待支付'">{{
                row.orsl_Payment_status
              }}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="patientName" label="患者姓名" width="120" align="center"> </el-table-column>
          <el-table-column prop="" label="项目数量" width="100" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.itemName && scope.row.itemName.split(',').length }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pslName" label="最新订单项目" align="center" width="200">
            <template slot-scope="scope">
              <span style="color: purple">{{ scope.row.pslName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="patientSex" label="患者性别" align="center" width="120"></el-table-column>
          <el-table-column prop="patientAge" label="患者年龄" align="center" width="120"></el-table-column>
          <el-table-column prop="patientIdcard" label="患者身份证" align="center" width="160">
            <template slot-scope="scope">
              <div v-for="(item, index) in getIdArr(scope.row)" :key="index">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="documentNo" label="订单编号" align="center" width="180"></el-table-column>
          <el-table-column prop="orderPrice" label="订单金额" align="center" width="100"></el-table-column>
          <el-table-column prop="orderCreateTime" label="订单创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="hosBarcode" label="客户条码" align="center" width="120"></el-table-column>
          <el-table-column prop="calName" label="客户名称" align="center" width="140"></el-table-column>
          <el-table-column prop="departmentName" label="科室" align="center" width="120"></el-table-column>
          <el-table-column prop="calCode" label="客户编码" align="center" width="120"></el-table-column>
          <el-table-column prop="" label="病历号" align="center" width="100"></el-table-column>
          <el-table-column prop="bedNo" label="床号" align="center" width="120"></el-table-column>
          <el-table-column prop="patientPhone" label="病人电话" align="center" width="120">
            <template slot-scope="scope">
              <div v-for="(item, index) in getPhoneArr(scope.row)" :key="index">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sampleType" label="样本类型" align="center" width="120"></el-table-column>
          <el-table-column prop="doctorName" label="送检医生" align="center" width="120"></el-table-column>
          <el-table-column prop="samplingTime" label="采样时间" align="center" width="150"></el-table-column>
          <el-table-column prop="备注" label="备注" align="center" width="200"></el-table-column>
          <el-table-column prop="payTime" label="支付时间" align="center" width="150"></el-table-column>
          <el-table-column prop="payStatus" label="支付状态" align="center" width="120"></el-table-column>
          <el-table-column prop="orcabSuccessfulCollectionTime" label="核收成功时间" align="center" width="150"></el-table-column>
          <el-table-column prop="receiveStatus" label="核收状态" align="center" width="120"></el-table-column>
          <el-table-column prop="orslRefundSign" label="退费标志" align="center" width="120"></el-table-column>
        </el-table>
      </div>

      <div class="bottom_pagination">
        <el-pagination
          background
          :current-page="pageNumber"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageNumberToatal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'OcrData',
  data() {
    return {
   
      isPrintShow: false,
      clinicInfo: {},
      laodTable: false,
      pageNumber: 1,
      pageSize: 20,
      pageNumberToatal: 0,
      tableData: [],
      searchName: '', //搜索名称
      dateValue: [], //搜索时间数组
      startTime: '', //左侧时间
      endTime: '', //右侧时间
      typeOptions: [
        {
          value: '3',
          label: '全部'
        },
        {
          value: '0',
          label: '单采'
        },
        {
          value: '1',
          label: '混采'
        }
      ],
      typeValue: '3',

    };
  },
  created() {
    this.clinicInfo = JSON.parse(sessionStorage.user);
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD 23:59:59');
    this.startTime = moment(new Date().getTime()).format('YYYY-MM-DD 00:00:00');
    this.dateValue = [this.startTime, this.endTime]; //回显
    this.getAllOverReportList(); //数据列表
  },
  mounted() {},
  methods: {
    // 导出按钮
    exportInfo() {
      // 节流方法
      this.throttleApi.throttle(this.exportInfo2);
    },
    // 导出方法
    exportInfo2() {   
      //step1.声明参数
      let vm = this;
      vm.$message.success("报表下载中，请耐心等待")
      const params = {
        calCode: vm.clinicInfo.cal_code,    
        startTime: vm.startTime,
        endTime: vm.endTime,      
        headers: {
          patientName: '姓名',
          patientSexName: '性别',        
          patientAge: '年龄',
          patientIdCard: '身份证',
          patientPhone: '电话',
          region: '社区',
          barcode: '条码',
          itemCode: '项目编码',
          itemName: '项目',
          doctorName:'医生姓名',
          doctorPhone:'医生电话',  
          createTime: '时间'
        }
      }
      //step2.下载表格
      // vm.downloadApi.download('http://10.161.2.60:8070/ysb-admin/batchDetailSummary/whaleExportOcrInfo', params);//本地
      vm.downloadApi.download('/ysb-admin'+'/batchDetailSummary/whaleExportOcrInfo', params);//线上
    },

    //获取身份证
    getIdArr(row) {
      let idArr = [];
      if (row.patientIdcard) {
        idArr = row.patientIdcard.split(',');
      } else {
        idArr = [];
      }
      return idArr ? idArr : [];
    },
    //获取手机号
    getPhoneArr(row) {
      let phoneArr = [];
      if (row.patientPhone) {
        phoneArr = row.patientPhone.split(',');
      } else {
        phoneArr = [];
      }
      return phoneArr ? phoneArr : [];
    },
    //选择报告类型
    chooseType(event) {
      this.pageNumber = 1;
      this.pageSize = 20;
      this.pageNumberToatal = 0;
      this.typeValue = event;
      this.getAllOverReportList();
    },
    // 获取列表
    getAllOverReportList() {
      const that = this;
      that.laodTable = true;
      let params = {
        calCode: that.clinicInfo.cal_code,
        barcode: that.searchName,
        packageType: that.typeValue === '3' ? '' : that.typeValue,
        startTime: that.startTime,
        endTime: that.endTime,
        current: that.pageNumber,
        size: that.pageSize
      };
      let personType = {
        category: 'YinJun'
      };
      request
        .post('/batchDetailSummary/whaleOcrBatchDetailList', params, personType)
        .then((res) => {
          that.laodTable = false;
          if (res.success) {
            that.tableData = res.data.records;
            that.pageNumberToatal = Number(res.data.total);
          } else {
            that.$message.error('抱歉，查询数据列表出错');
          }
        })
        .catch((err) => {
          that.laodTable = false;
          that.$message.error('抱歉，查询数据列表出错');
        });
    },
    // 页码数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAllOverReportList();
    },
    // 页码
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getAllOverReportList();
    },
    // 点击搜索
    goSearch() {
      this.pageNumber = 1;
      this.getAllOverReportList();
    },
    //清除按钮
    clearSearchName() {
      this.searchName = '';
      this.pageNumber = 1;
      this.pageSize = 20;
      this.pageNumberToatal = 0;
      this.getAllOverReportList();
    },
    // 选择时间
    chooseDate(event) {  
      if (event) {
        this.startTime = moment(event[0]).format('YYYY-MM-DD 00:00:00');
        this.endTime = moment(event[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD');
      }
      this.pageNumber = 1;
      this.pageSize = 20;
      this.pageNumberToatal = 0;
      this.getAllOverReportList();
    }
  }
};
</script>

<style lang="scss" scoped>
.view_report:hover {
  color: #36b6ff !important;
  font-weight: bold;
}
.body {
  width: 100%;
  height: calc(100vh - 90px);
  box-sizing: border-box;
  position: relative;
  .batch-print {
    position: absolute;
    top: 0;
    left: 20000px;
  }

  ::v-deep .el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0px !important;
    border-radius: 30px 30px 0px 0px !important;
  }
  ::v-deep .el-card {
    border-radius: 30px 30px 0px 0px !important;
  }
  .box_card {
    height: calc(100vh - 90px);
    box-sizing: border-box;

    .header {
      box-sizing: border-box;
      padding: 10px 30px;
      background-color: #f0feff;
      border-radius: 30px 30px 0px 0px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      @media screen and (max-width: 1024px) {
        padding: 10px 12px;
      }

      .header_title {
        font-size: 20px;
        color: #2d99d7;
      }

      .header_right {
        display: flex;
        .header_item {
          display: flex;
          align-items: center;
          align-content: center;
          margin: 0 5px;
          .item_title {
            color: #333;
            font-size: 16px;
            font-weight: 400;
            margin-right: 20px;
            margin-left: 20px;
            flex-shrink: 0;
          }

          &:first-child > .item_title {
            margin-left: 0;
          }

          @media screen and (max-width: 1024px) {
            .item_title {
              letter-spacing: 13px;
            }
          }

          ::v-deep .el-date-editor {
            width: 240px;
          }

          // /deep/ .el-button{
          //   width: 120px;
          //   height: 44px;
          //   background: #2D99D7;
          //   border-radius: 16px;
          //   font-size: 16px;
          //   color: #fff;
          // }

          // 更改输入框的大小 圆角 // 去掉了为了适配 pad
          // /deep/ .el-input{
          //   //width: 240px;
          // }

          // /deep/ .el-range-editor--small.el-input__inner {
          //   height: 44px !important;
          // }

          // /deep/ .el-input__inner {
          //   border-radius: 15px !important;
          //   border: 1px solid #2d99d7 !important;
          // }

          // /deep/ .el-range-editor--small .el-range-separator {
          //   line-height: 34px;
          //   font-size: 15px;
          //   color: #999999;
          // }

          // /deep/ .el-input--small .el-input__inner {
          //   height: 44px;
          //   line-height: 44px;
          // }
        }
      }
    }
    .middle_table {
      height: calc(100% - 120px);
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px;
    }
    .bottom_pagination {
      width: 100%;
      margin-top: 10px;
      height: 40px;
      display: flex;
      justify-content: center;
      justify-items: center;
      align-items: center;
    }
  }
}
</style>
